'use strict';

module.exports = ['$scope', '$modalInstance', 'config', 'MaterialSvc', function ($scope, $modalInstance, config, MaterialSvc) {
    // ------------------
    // scope functions
    // ------------------
    $scope.confirmDelete = function () {
        MaterialSvc.delete(config.material_id, $scope.$root.plant).success(function (data) {
            $modalInstance.close();
            if (angular.isFunction(config.callback)) {
                config.callback(data);
            }
        }).error(function (data) {
            console.error(data);
        });
    };

    $scope.cancelClick = function () {
        $modalInstance.close();
    };

    $scope.title = "Delete Material";
    $scope.message = "Are you sure you want to delete this material?";
}];